import { makeStyles } from '@mui/styles';
import { defaultIcon } from '../../default';

const chevronLeftDefault: any = {
  width: '0',
  '&:after, &:before': {
    width: '.6em',
    height: '150%',
    maxHeight: '150%',
    top: '-.185em',
    transform: 'translateX(-50%) rotate(-45deg)',
    borderRadius: '.05em',
  },
  '&:after': {
    top: 'auto',
    bottom: '-.185em',
    transform: 'translateX(-50%) rotate(45deg)',
  },
};

const chevronRightDefault: any = {
  width: '0',
  '&:after, &:before': {
    width: '.6em',
    height: '150%',
    maxHeight: '150%',
    top: '-.185em',
    transform: 'translateX(-50%) rotate(45deg)',
    borderRadius: '.05em',
  },
  '&:after': {
    top: 'auto',
    bottom: '-.185em',
    transform: 'translateX(-50%) rotate(-45deg)',
  },
};

const useStyles = makeStyles({
  chevronUp: {
    ...defaultIcon,
    ...chevronRightDefault,
    transform: 'translate(-50%, -50%) rotate(-90deg)',
  },
  chevronDown: {
    ...defaultIcon,
    ...chevronLeftDefault,
    transform: 'translate(-50%, -50%) rotate(-90deg)',
  },
  chevronLeft: {
    ...defaultIcon,
    ...chevronLeftDefault,
  },
  chevronRight: {
    ...defaultIcon,
    ...chevronRightDefault,
  },
});

export default useStyles;
